// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.application-success {
    padding: 20px;
    background-color: white;
    margin: 20px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .application-success h1 {
    color: #333;
  }
  
  .application-success p {
    color: #555;
    margin: 20px 0;
  }
  
  .application-success a {
    text-decoration: none;
    color: #fff;
    background-color: #333;
    padding: 10px 20px;
    border-radius: 5px;
  }
  
  .application-success a:hover {
    background-color: #555;
  }`, "",{"version":3,"sources":["webpack://./src/components/ApplicationSuccess.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB","sourcesContent":[".application-success {\n    padding: 20px;\n    background-color: white;\n    margin: 20px;\n    border-radius: 5px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    text-align: center;\n  }\n  \n  .application-success h1 {\n    color: #333;\n  }\n  \n  .application-success p {\n    color: #555;\n    margin: 20px 0;\n  }\n  \n  .application-success a {\n    text-decoration: none;\n    color: #fff;\n    background-color: #333;\n    padding: 10px 20px;\n    border-radius: 5px;\n  }\n  \n  .application-success a:hover {\n    background-color: #555;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
